export const MOBILE_TABS_LIST = 'max-sm:w-full max-sm:snap-x max-sm:snap-proximity'

export const MOBILE_TABS_TRIGGER = 'max-sm:snap-center'
